import React from 'react'

import FormattedMessage from 'components/FormattedMessage'
import Spinner from 'components/Spinner'

import classNames from 'helpers/css'

import styles from './index.module.scss'

const Placeholder: React.FC<PlaceholderProps> = ({ loading }) => (
  <div className={classNames(styles, 'projects-dropdown__for-consultants__placeholder')}>
    {loading ? (
      <Spinner />
    ) : (
      <FormattedMessage id="common.notGiven" />
    )}
  </div>
)

type PlaceholderProps = {
  loading?: boolean
}

export default Placeholder
